import { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { PageWrapper } from '../../components/layout/PageLayout';
import TaskEditYelpContainer from '../../components/tasks/editYelp/TaskEditYelp.container';

type TaskEditPageProps = {
  code?: string;
};

const TaskEditYelpPage: FC<RouteComponentProps<TaskEditPageProps>> = ({ match }) => {
  const code = match.params.code;
  return (
    <PageWrapper>
      <TaskEditYelpContainer code={code} />
    </PageWrapper>
  );
};

export default TaskEditYelpPage;
